import React, { Component, Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Buying by tender</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    { url: '/ways-to-purchase', name: 'Ways to purchase' },
                    {
                      url: '/ways-to-purchase/tender',
                      name: 'Tender',
                    },
                  ]}
                />
                <h2 className="lead text-center">Tender</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    ​
                    <p>
                      A tender is very common in today’s market, with more buyers than houses. In this scenario multiple
                      buyers submit offers before a deadline, and then the vendor decides if they want to accept one
                      offer, negotiate with one or more of the buyers, or accept no offers. A property can be sold
                      before the deadline, but most of the REA’s that we asked about this advised us not to offer ahead
                      of the deadline due to it being largely a sellers market and early offers usually only served to
                      push up the price at the end of the process. If interested buyers are registered with the agent,
                      they are notified of any early offers also, which can force them to put in early offers also. As
                      with all of the other offer methods, the sale and purchase agreement is completed and may include
                      conditions.
                    </p>
                    <p>
                      After the deadline is past the wait begins. The agent will look at the tender offers with the
                      vendor and if you’re not in the top few then you’ll hear from them pretty quickly. You are allowed
                      to ask where the higher offers were sitting, but they aren’t obligated to tell you. The vendor may
                      choose to negotiate with any, or none, of the offers to attempt to increase the price. An
                      unconditional offer will often look more attractive than a higher $$ amount with conditions, so it
                      may not just come down to the money. Remember to stick to your budget! If you are the lucky winner
                      of a tender the agent will guide you through the next steps, these include signing the documents,
                      transferring the deposit, and completing any of your conditions before the settlement date
                    </p>{' '}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ways_to_purchase/Tender.jsx